import * as ACTIONS from '../constants/actions';
import {combineReducers} from 'redux';

export default combineReducers({
    user: (state = null, action) => {
        switch (action.type) {
            case ACTIONS.SET_USER:
                return action.payload;
            case ACTIONS.CLEAR_USER:
                return null;
            default:
                return state;
        }
    }
})